import React from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { useAuth } from '../../context/AuthContext';
import { Home, Inbox, GitBranch, Wrench, FileText, Bookmark, Lightbulb, Briefcase, Workflow, Library, LogOut } from 'lucide-react';

const NavSidebar = () => {
  const { currentView, setCurrentView } = useAppState();
  const { logout, user } = useAuth();

  // Get first name from full_name or username
  const getFirstName = () => {
    if (user?.full_name) {
      return user.full_name.split(' ')[0];
    }
    return user?.username || 'User';
  };

  const navItems = [
    { id: 'command-center', label: 'Command Center', icon: Home },
    { id: 'capture', label: 'Capture', icon: Inbox },
    { id: 'pipeline', label: 'Pipeline', icon: GitBranch },
    { id: 'ideas', label: 'Ideas', icon: Lightbulb },
    { id: 'portfolio', label: 'Portfolio', icon: Briefcase },
    { id: 'tools', label: 'Tools', icon: Wrench },
    { id: 'prompts', label: 'Prompts', icon: FileText },
    { id: 'bookmarks', label: 'Bookmarks', icon: Bookmark },
    { id: 'workflows', label: 'Workflows', icon: Workflow, isPlaceholder: true },
    { id: 'knowledge', label: 'Knowledge', icon: Library, isPlaceholder: true }
  ];

  return (
    <aside className="nav-sidebar" data-testid="nav-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img 
            src="/covenant-logo.png" 
            alt="Covenant Labs" 
            className="sidebar-logo"
          />
          <h1 className="sidebar-title" data-testid="sidebar-title">Covenant Command</h1>
        </div>
        {user && (
          <div className="sidebar-user">
            <span className="sidebar-user-greeting">Welcome, {getFirstName()}</span>
          </div>
        )}
      </div>
      <nav className="sidebar-nav">
        {navItems.map(item => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              data-testid={`nav-item-${item.id}`}
              onClick={() => !item.isPlaceholder && setCurrentView(item.id)}
              className={`nav-item ${
                currentView === item.id ? 'nav-item-active' : ''
              } ${item.isPlaceholder ? 'nav-item-placeholder' : ''}`}
              disabled={item.isPlaceholder}
            >
              <Icon className="nav-icon" size={18} />
              <span>{item.label}</span>
              {item.isPlaceholder && (
                <span className="placeholder-badge">Soon</span>
              )}
            </button>
          );
        })}
      </nav>
      <div className="sidebar-footer">
        <button 
          onClick={logout}
          className="nav-item nav-item-logout"
          data-testid="logout-btn"
        >
          <LogOut className="nav-icon" size={18} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default NavSidebar;
